import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid h-100 p-0" }
const _hoisted_2 = { class: "row h-100 g-0" }
const _hoisted_3 = { class: "col-12 h-100" }
const _hoisted_4 = {
  class: "overflow-y-auto h-100 pt-4 px-3",
  style: {"height":"calc(100vh - 60px)"}
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "card main-card border-0" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = {
  class: "btn-group w-100",
  role: "group"
}
const _hoisted_10 = {
  class: "btn btn-outline-primary",
  for: "yearly"
}
const _hoisted_11 = {
  class: "btn btn-outline-primary",
  for: "monthly"
}
const _hoisted_12 = { class: "mb-5" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "row g-3" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-label" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-label" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "row g-3" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table table-bordered" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "card total-card" }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "total-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("project.consumption")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "consumptionType",
                    id: "yearly",
                    value: "yearly",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consumptionType) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.consumptionType]
                  ]),
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("project.consumptionComponent.yearly")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "consumptionType",
                    id: "monthly",
                    value: "monthly",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.consumptionType) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.consumptionType]
                  ]),
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("project.consumptionComponent.monthly")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("project.consumptionComponent.energyPrice")), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("project.consumptionComponent.importPrice")), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.energyPrices.import) = $event)),
                        min: "0",
                        step: "0.01"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.energyPrices.import,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text" }, "€/kWh", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("project.consumptionComponent.exportPrice")), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.energyPrices.export) = $event)),
                        min: "0",
                        step: "0.01"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.energyPrices.export,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text" }, "€/kWh", -1))
                    ])
                  ])
                ])
              ]),
              (_ctx.consumptionType === 'yearly')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t("project.consumptionComponent.yearlyConsumption")), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "F1", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.yearlyConsumption.F1) = $event)),
                          min: "0",
                          step: "0.01"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.yearlyConsumption.F1,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "F2", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.yearlyConsumption.F2) = $event)),
                          min: "0",
                          step: "0.01"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.yearlyConsumption.F2,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "F3", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.yearlyConsumption.F3) = $event)),
                          min: "0",
                          step: "0.01"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.yearlyConsumption.F3,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.consumptionType === 'monthly')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.$t("project.consumptionComponent.monthlyConsumption")), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("table", _hoisted_30, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("project.consumptionComponent.month")), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("th", null, "F1", -1)),
                            _cache[13] || (_cache[13] = _createElementVNode("th", null, "F2", -1)),
                            _cache[14] || (_cache[14] = _createElementVNode("th", null, "F3", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.$t(
                              `project.consumptionComponent.months.${_ctx.monthKeys[index]}`
                            )), 1),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control form-control-sm",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.monthlyConsumption[index].F1) = $event),
                                  min: "0",
                                  step: "0.01"
                                }, null, 8, _hoisted_31), [
                                  [
                                    _vModelText,
                                    _ctx.monthlyConsumption[index].F1,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control form-control-sm",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.monthlyConsumption[index].F2) = $event),
                                  min: "0",
                                  step: "0.01"
                                }, null, 8, _hoisted_32), [
                                  [
                                    _vModelText,
                                    _ctx.monthlyConsumption[index].F2,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control form-control-sm",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.monthlyConsumption[index].F3) = $event),
                                  min: "0",
                                  step: "0.01"
                                }, null, 8, _hoisted_33), [
                                  [
                                    _vModelText,
                                    _ctx.monthlyConsumption[index].F3,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("project.consumptionComponent.grandTotal")), 1),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.grandTotal.toFixed(2)) + " kWh ", 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}